export default "__VITE_ASSET__CjI5j6Zh__"